export const visit = (vm, at) => {
at({ "fr": { "conversationsVisitorUIAvailability": { "sameDay": "Nous reviendrons aujourd'hui \xE0 {{time}}", "nextDay": "Nous reviendrons demain \xE0 {{time}}", "nextWeek": "Nous reviendrons {{dayOfWeek}} \xE0 {{time}}" } } });
};